/* MOG MINTS, the mobile navigation drawer (2026-09-16).

   ⚠ WHY THIS FILE EXISTS. base.css has carried .bar__menu and .navdraw styles since the port,
   and five per-template sheets carried `@media (max-width:900px){ .bar nav a:not(.bar__shop)
   {display:none} }`. The markup they hand off to was never written. So below 900px the header
   hid every link except Shop MOG and handed off to a hamburger that did not exist: SCIENCE,
   ABOUT and CONTACT were unreachable from the header on a phone, on the home, product, science,
   about, mog30 and community pages. Confirmed in the live DOM on 2026-09-16 before this landed.

   LOADED BY sections/header.liquid ITSELF, not routed in theme.liquid, because the header is on
   every template and its behaviour has to travel with it. Same pattern as index-what loading
   mint-flip.js. The responsive show/hide rules moved into base.css for the same reason: they were
   drifting per sheet, which is what produced this bug.

   THE DRAWER'S LINKS ARE THE SAME NODES AS THE BAR'S, captured once in Liquid and printed twice,
   so a menu change in admin cannot make the two disagree. */
(function () {
  'use strict';

  var btn  = document.querySelector('.bar__menu');
  var draw = document.getElementById('navdraw');
  if (!btn || !draw) return;

  var root = document.documentElement;

  /* offsetParent is null inside position:fixed, which is the trap the cart drawer hit, so
     visibility is measured with getClientRects instead. */
  function focusables() {
    return [].slice.call(draw.querySelectorAll('a[href],button:not([disabled])'))
      .filter(function (el) { return el.getClientRects().length > 0; });
  }

  function open() {
    draw.hidden = false;
    root.classList.add('nav-open');
    btn.setAttribute('aria-expanded', 'true');
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function close(returnFocus) {
    if (draw.hidden) return;
    draw.hidden = true;
    root.classList.remove('nav-open');
    btn.setAttribute('aria-expanded', 'false');
    if (returnFocus) btn.focus();
  }

  btn.addEventListener('click', function () {
    if (draw.hidden) open(); else close(true);
  });

  /* A tap on the drawer's own ground, not on a link, closes it. The panel deliberately fills the
     viewport below the bar so there is no thin scrim to miss. */
  draw.addEventListener('click', function (e) {
    if (e.target === draw || e.target.tagName === 'NAV') close(true);
  });

  document.addEventListener('keydown', function (e) {
    if (draw.hidden) return;
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Rotating a phone to landscape can cross the breakpoint, which would leave the drawer open
     over a bar that has its full nav back, and body scroll still locked. */
  var mq = matchMedia('(min-width: 901px)');
  var onChange = function (e) { if (e.matches) close(false); };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);

  /* An in-page anchor does not navigate, so nothing would close the drawer behind it. */
  draw.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (a) close(false);
  });
})();
